<div class="table-wrapper">
  <table>
    <thead>
      <tr>
        @for (col of columns; track $index) {
          <th [style.width]="col.width" [ngStyle]="col.style">
            @if (loading) {
              <div class="skeleton-box-heading"></div>
            } @else {
              {{ col.header }}
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @if (loading) {
        @for (i of skeletonRowsArray; track $index) {
          <tr>
            @for (col of columns; track $index) {
              <td>
                <div class="skeleton-box"></div>
              </td>
            }
          </tr>
        }
      } @else {
        @for (item of data; track $index) {
          <ng-container
            *ngTemplateOutlet="
              rowTemplate;
              context: { $implicit: item, index: $index }
            "
          ></ng-container>
        }
        @if (data.length === 0) {
          <tr>
            <td [attr.colspan]="columns.length" class="no-results">
              <div class="no-data-message">{{ noResultsMessage }}</div>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
